import api from './api';

// Generate unique token key based on app name or environment variable
const getAuthTokenKey = () => {
    // Debug: Check what we're getting from environment
    console.log('🔍 VITE_APP_NAME from client:', import.meta.env.VITE_APP_NAME);
    console.log('🔍 All VITE env vars:', Object.keys(import.meta.env).filter(key => key.startsWith('VITE_')));
    
    // Check for environment variable first
    if (import.meta.env.VITE_AUTH_TOKEN_KEY) {
        return import.meta.env.VITE_AUTH_TOKEN_KEY;
    }
    
    // Fallback to app-specific key
    const appName = import.meta.env.VITE_APP_NAME;
    console.log('🔑 Using app name:', appName);
    return `${appName}_auth_token`;
};

const AUTH_TOKEN_KEY = getAuthTokenKey();

class AuthService {
    setToken(token) {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
        api.setAuthHeader(token);
    }

    getToken() {
        return localStorage.getItem(AUTH_TOKEN_KEY);
    }

    removeToken() {
        localStorage.removeItem(AUTH_TOKEN_KEY);
        api.setAuthHeader(null);
    }

    async login(email, password) {
        try {
            console.log('Attempting login with:', { email });
            const data = await api.post('/auth/login', { email, password });
            console.log('Login response data:', data);
            
            if (data.token) {
                this.setToken(data.token);
                return data;
            } else {
                throw new Error('No token received from server');
            }
        } catch (error) {
            console.error('Login service error:', error);
            throw error;
        }
    }

    async logout() {
        this.removeToken();
    }

    async getCurrentUser() {
        try {
            const response = await api.get('/auth/verify');
            return response;
        } catch (error) {
            console.error('Get current user error:', error);
            throw error;
        }
    }

    async isAuthenticated() {
        const token = this.getToken();
        if (!token) {
            return false;
        }

        try {
            // Verify token with server
            const response = await api.get('/auth/verify');
            return response.valid === true;
        } catch (error) {
            console.error('Token verification failed:', error);
            // Only remove token for auth-specific errors (401/403)
            // Don't remove for network errors during page load
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                console.log('Token is invalid (401/403), removing...');
                this.removeToken();
            }
            return false;
        }
    }

    // Synchronous version for immediate checks (only checks existence)
    hasToken() {
        const token = this.getToken();
        return !!token;
    }

    // Initialize auth state from localStorage - returns auth status
    async initializeAuth() {
        const token = this.getToken();
        if (token) {
            api.setAuthHeader(token);
            // For initialization, just trust the token exists
            // Let the API interceptor handle invalid tokens during actual requests
            return true;
        }
        return false;
    }
}

const authService = new AuthService();
export default authService; 